module.exports = __webpack_public_path__ + "img/Icon-social-vk.4b98d1bc.svg";